import { gql } from '../../../../../hooks'

export const DELETE_LUBRICANTS = gql`
  mutation AdministrationDeleteLubricantLubricants($id: ID!) {
    aDelete(path: "lubricant/lubricants", id: $id) {
    }
  }
`

export const LIST_LUBRICANTS = gql`
  query AdministrationListLubricantLubricants(
    $page: Int
    $limit: Int
    $filter: JSONObject
  ) {
    aList(
      path: "lubricant/lubricants"
      filter: $filter
      page: $page
      limit: $limit
    ) {
      pagination {
        page
        limit
        number_of_pages
      }
    }
  }
`
